import { FormLabel, Input, Button } from "@components";

export default function SaveAsPage({
  saveAsName,
  onNameChange,
  loading,
  onBack,
  onSubmit,
}) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="p-5 space-y-4"
    >
      <div>
        <FormLabel>Template name</FormLabel>
        <Input
          value={saveAsName}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="New template name"
          maxLength={50}
        />
      </div>
      <div className="flex gap-2">
        <Button
          type="button"
          className="shrink-0 rounded-lg"
          onClick={onBack}
          disabled={loading}
        >
          Back
        </Button>
        <Button
          type="submit"
          color="primary"
          className="shrink-0 grow rounded-lg"
          disabled={!saveAsName.trim()}
          submitting={loading}
        >
          Save as new template
        </Button>
      </div>
    </form>
  );
}
